import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import Landing from "@/pages/Landing";
import FashionLuxury from "@/pages/FashionLuxury";
import PatentLabel from "@/pages/PatentLabel";
import OreganoScan from "@/pages/OreganoScan";
import Tenute from "@/pages/Tenute";
import Origano from "@/pages/Origano";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/moda-lusso" element={<FashionLuxury />} />
            <Route path="/brevetti/etichetta-intelligente" element={<PatentLabel />} />
            <Route path="/brevetti/oregano-scan" element={<OreganoScan />} />
            <Route path="/tenute" element={<Tenute />} />
            <Route path="/origano" element={<Origano />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
